module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.0.0.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR1.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR1.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR1.w.1.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PP1"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PR2"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR2.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR2.w.0.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PR1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-top": "5em"
    },
    attrs: {
      "id": "block.2.0.0.box.544.856.565.190.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR1.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "142%",
      "text-align": "center",
      "font-weight": "bold",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.2.0.0.box.610.856.430.106.q.80"
    }
  }, [_vm._v("Metairie")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR1.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "104%",
      "text-align": "center",
      "font-weight": "bold",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.2.0.1.box.544.994.565.52.q.80"
    }
  }, [_vm._v("A Tongue of Land to Pasture")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR3"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR3.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR3.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR3.w.1.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PR3"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em",
      "margin-top": "5em"
    },
    attrs: {
      "id": "block.4.0.0.box.434.832.762.188.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR3.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "200%",
      "text-indent": "0",
      "text-align": "center",
      "font-weight": "bold",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.4.0.0.box.434.832.762.188.q.90"
    }
  }, [_vm._v("Metairie")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.4.1.0.box.316.1077.1004.90.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR3.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "122%",
      "text-indent": "0",
      "text-align": "center",
      "font-weight": "bold",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.4.1.0.box.316.1077.1004.90.q.80"
    }
  }, [_vm._v("A Tongue of Land to Pasture")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.4.2.0.box.404.1270.828.77.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR3.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "118%",
      "text-indent": "0",
      "text-align": "center",
      "font-weight": "bold",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.4.2.0.box.404.1270.828.77.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR3.w.2.0.0"
    }
  }), _vm._v("Monsignor Henry C. Bezou")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    staticStyle: {
      "margin-top": "5em"
    },
    attrs: {
      "id": "block.4.3.0.box.766.2180.104.94.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR3.w.3.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0002.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR3.w.3.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.4.4.0.box.476.2298.681.77.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR3.w.4.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center",
      "font-weight": "bold",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.4.4.0.box.476.2298.681.30.q.90"
    }
  }, [_vm._v("PELICAN PUBLISHING COMPANY")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR3.w.4.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.4.4.1.box.704.2345.223.30.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR3.w.3.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR3.w.4.0.0"
    }
  }), _vm._v("Gretna 2003")]), _c('a', {
    attrs: {
      "id": "GBS.PR3.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR3.w.6.0.0"
    }
  })])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR4"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR4.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PR4"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em",
      "margin-top": "3em"
    },
    attrs: {
      "id": "block.5.0.0.box.648.491.426.141.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR4.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center",
      "margin-left": "0",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.5.0.0.box.648.491.426.40.q.70"
    }
  }, [_vm._v("Copyright © 1973, 2001")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR4.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.5.0.1.box.691.543.343.38.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR4.w.0.1.0"
    }
  }), _vm._v("By Henry C. Bezou")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR4.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.5.0.2.box.697.592.330.40.q.90"
    }
  }, [_vm._v("All rights reserved")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.5.1.0.box.560.693.604.193.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR4.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center",
      "margin-left": "0",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.5.1.0.box.688.693.347.41.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR4.w.1.0.0"
    }
  }), _vm._v("First printing, 1973")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR4.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.5.1.1.box.661.744.401.40.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR4.w.1.1.0"
    }
  }), _vm._v("Second printing, 1979")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR4.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.5.1.2.box.588.794.549.41.q.80"
    }
  }, [_vm._v("First paperback printing, 1997")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR4.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.5.1.3.box.560.845.604.41.q.80"
    }
  }, [_vm._v("Second paperback printing, 2003")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_inset_box",
    staticStyle: {
      "margin-top": "3em"
    },
    attrs: {
      "id": "block.5.2.0.box.366.1093.1062.140.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR4.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_inset_box",
    staticStyle: {
      "text-align": "center",
      "margin-left": "0",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.5.2.0.box.366.1093.1062.140.q.70"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR4.w.2.0.0"
    }
  }), _vm._v("The ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("word ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("\"Pelican\" ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("depiction ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("a ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("pelican ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("are ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("trademarks ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Pelican ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Publishing ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Company, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Inc., ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("are ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("registered ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR4.w.2.1.0"
    }
  }), _vm._v("in ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("U.S. ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Patent ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Trademark ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Office. ")])])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.5.3.0.box.429.1390.931.39.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR4.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "0",
      "text-align": "center",
      "font-weight": "bold",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.5.3.0.box.429.1390.931.39.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR4.w.3.0.0"
    }
  }), _vm._v("Library of Congress Cataloging-in-Publication Data")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.5.4.0.box.295.1490.1195.338.q.30"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR4.w.4.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-left": "0",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.5.4.0.box.295.1490.299.38.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR4.w.4.0.0"
    }
  }), _vm._v("Bezou, Henry C.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR4.w.4.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.5.4.1.box.340.1538.638.39.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR4.w.4.1.0"
    }
  }), _vm._v("Metairie: ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("A ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Tongue ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Land ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("to ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Pasture. ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR4.w.4.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.5.4.2.box.339.1588.440.39.q.70"
    }
  }, [_vm._v("Bibliography: p. 163-169")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR4.w.4.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.5.4.3.box.343.1638.1147.39.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR4.w.4.2.0"
    }
  }), _vm._v("1. Metairie—History. 2. St. Francis Xavier Church, Metairie, La.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR4.w.4.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.5.4.4.box.296.1688.129.28.q.60"
    }
  }, [_vm._v("I. Title.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR4.w.4.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.5.4.5.box.296.1736.641.31.q.40"
    }
  }, [_vm._v("F379.M47B49 917.63'  38  73-17038")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR4.w.4.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.5.4.6.box.297.1786.454.42.q.40"
    }
  }, [_vm._v("ISBN  1-56554-279-7 (pb)")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em",
      "margin-top": "3em"
    },
    attrs: {
      "id": "block.5.5.0.box.476.2012.843.29.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR4.w.5.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "0",
      "text-align": "center",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.5.5.0.box.476.2012.843.29.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR4.w.5.0.0"
    }
  }), _vm._v("Manufactured in the United States of America")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.5.6.0.box.520.2111.695.66.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR4.w.6.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center",
      "margin-left": "0",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.5.6.0.box.523.2111.684.32.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR4.w.6.0.0"
    }
  }), _vm._v("Published by Pelican Publishing Company, Inc.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PR4.w.6.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.5.6.1.box.520.2151.695.26.q.70"
    }
  }, [_vm._v("1000 Burmaster Street, Gretna, Louisiana 70053")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.5.7.0.box.669.2241.392.32.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR4.w.7.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.5.7.0.box.669.2241.392.32.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR4.w.7.0.0"
    }
  }), _vm._v("Designed by Oscar Richard")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR5"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR5.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR5.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR5.w.1.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PR5"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em",
      "margin-left": "2em",
      "margin-right": "2em",
      "margin-top": "5em"
    },
    attrs: {
      "id": "block.6.0.0.box.677.677.299.42.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR5.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-align": "center"
    },
    attrs: {
      "id": "para.6.0.0.box.677.677.299.42.q.70"
    }
  }, [_vm._v("To my Mother")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em",
      "margin-left": "2em",
      "margin-right": "2em",
      "margin-top": "0.5em"
    },
    attrs: {
      "id": "block.6.1.0.box.525.756.599.32.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR5.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-align": "center"
    },
    attrs: {
      "id": "para.6.1.0.box.525.756.599.32.q.70"
    }
  }, [_vm._v("LYDIA BOULIGNY BEZOU")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-left": "2em",
      "margin-right": "2em",
      "margin-top": "0.5em"
    },
    attrs: {
      "id": "block.6.2.0.box.151.837.1344.98.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PR5.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-align": "center",
      "margin-left": "0",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.6.2.0.box.151.837.1344.98.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR5.w.2.0.0"
    }
  }), _vm._v("who once wistfully asked after listening to excerpts from this book: "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR5.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR6"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR6.w.0.0.0"
    }
  }), _vm._v("\"Cher, ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR7"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.0.0.0"
    }
  }), _vm._v("qui ")]), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.0.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.1.0.0"
    }
  }), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("lira ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR7.w.2.0.0"
    }
  }), _vm._v("tout ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR7.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.2.2.0"
    }
  }), _vm._v("cela?\" ")])]), _c('a', {
    attrs: {
      "id": "GBS.PR7.w.2.3.0"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page full_page_skipped",
    attrs: {
      "id": "ORIG-GBS.PR7"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PR7.w.2.3.0.1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b8be3fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content-0003.vue
// module id = 54
// module chunks = 0